import { Button, TextField, Toolbar, Typography } from '@mui/material';
import { getUserFullName } from 'app/utils/appHelpers';
import { useState } from 'react';
import { useTemplateFontSettings } from 'styles/templateFontSettings';

function PeriodicReportDataTableToolbar({ pageTitle, data2, setData, setFileDialogStatus, setHighlightQuery }) {


    const { baseFontSize } = useTemplateFontSettings();
    const [searchText, setSearchText] = useState("");


    const handleChangeSearchText = (text) => {
        if (text !== "") {
            const filterData = data2.filter(
                (item) =>
                    item.inst.toLocaleLowerCase().includes(text.toLocaleLowerCase()) ||
                    item.unit.name.toLocaleLowerCase().includes(text.toLocaleLowerCase()) ||
                    item.period.toLocaleLowerCase().includes(text.toLocaleLowerCase()) ||
                    getUserFullName(item.user).toLocaleLowerCase().includes(text.toLocaleLowerCase()) ||
                    item.year === Number(text)
            );

            setSearchText(text);
            setHighlightQuery(text);
            setData(filterData);
        } else {
            setSearchText(text);
            setHighlightQuery(text);
            setData(data2);
        }
    };


    return (
        <Toolbar className="table-header row" sx={{ justifyContent: 'space-between', background: '#e1e1e1' }}>
            <div className="title">
                <Typography variant="title" sx={{ fontSize: baseFontSize }}>{pageTitle}</Typography>
            </div>

            <div>


                <Button
                    variant="contained"
                    sx={{ marginTop: '14px', marginRight: '10px', fontSize: baseFontSize }}
                    size="large"
                    onClick={() => setFileDialogStatus(true)}
                >
                    Rapor Yükle
                </Button>



                <TextField
                    id="searchText1xe"
                    value={searchText}
                    onChange={(e) => handleChangeSearchText(e.target.value)}
                    margin="dense"
                    label={"Arama Yap"}
                    className="mr-4"
                    // autoFocus
                    style={{ width: "400px", background: 'white' }}
                    placeholder={'Bilgi'}
                    InputProps={{
                        style: { fontSize: baseFontSize }
                    }}
                    InputLabelProps={{
                        style: { fontSize: baseFontSize }
                    }}
                />
            </div>




        </Toolbar>
    );
};

export default PeriodicReportDataTableToolbar